/* eslint-disable */
import React, { useEffect } from 'react';
import { t } from '@web-solutions/module-localization';
import Analytics from '@web-solutions/module-analytics';
import { useNav } from 'src/onboarding/hooks/nav';
import { useStore } from 'src/onboarding/store/store';
import { Screen, Title, Options } from '../_shared/Screen';
import { OptionCard } from '../_shared/OptionCard';
import { PrimaryButton } from '../_shared/PrimaryButton';

const OPTIONS = ['suits', 'barber', 'morning', 'confident', 'stress', 'personality'];

function Page() {
  const { onNext, onPrev, currentIndex } = useNav();
  const selected = (useStore((s: any) => s.hairstyleHappiestResult) as string[]) || [];
  const setSelected = useStore((s: any) => s.setHairstyleHappiestResult) as (v: string[]) => void;

  useEffect(() => {
    Analytics.trackEvent(`step${currentIndex + 1}`, 'view', { page: 'hairstyle-happiest-result' });
  }, []);

  const toggle = (id: string) => {
    setSelected(selected.includes(id) ? selected.filter((x) => x !== id) : [...selected, id]);
  };

  const next = () => {
    Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', { page: 'hairstyle-happiest-result', answer: selected.join(',') });
    onNext();
  };

  return (
    <Screen
      progress={88}
      hideBack={currentIndex === 0}
      onBack={onPrev}
      footer={<PrimaryButton onClick={next} disabled={selected.length === 0}>{t('hairstyleHappiestResult.cta')}</PrimaryButton>}
    >
      <Title>{t('hairstyleHappiestResult.title')}</Title>
      <Options>
        {OPTIONS.map((id) => (
          <OptionCard
            key={id}
            mode="multi"
            label={t(`hairstyleHappiestResult.options.${id}`)}
            selected={selected.includes(id)}
            onClick={() => toggle(id)}
          />
        ))}
      </Options>
    </Screen>
  );
}

export default Page;
